export default function SectionSeparator() {
    return <hr className="border-accent-2 mt-28 mb-24" />
}